const flavors = [
  {
    zh: '一味',
    en: 'FLAVOR',
    index: '01',
    line: '从一口中国味道开始。',
    body: 'NOMOISM 不是简单复制食物，而是重新理解它——一份味道里，藏着一方水土与一段生活记忆。',
    image:
      'https://readdy.ai/api/search-image?query=Stylized%20close%20up%20of%20Chinese%20cuisine%20ingredients%20arranged%20artfully%20with%20rising%20steam%20warm%20amber%20and%20cinnabar%20red%20tones%20on%20a%20minimal%20rice%20paper%20background%20editorial%20food%20still%20life%20soft%20directional%20light&width=900&height=1200&seq=nomo-formula-flavor-01&orientation=portrait',
    tag: '中国美食',
  },
  {
    zh: '一境',
    en: 'PLACE',
    index: '02',
    line: '一种味道，从来不只是味道。',
    body: '它来自城市、山川、江河、街巷、气候、方言与生活方式。食物是入口，风土才是世界。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20east%20asian%20landscape%20with%20layered%20mountains%20calm%20lake%20and%20drifting%20mist%20celadon%20green%20and%20warm%20beige%20palette%20minimalist%20ink%20wash%20painting%20mood%20serene%20morning%20light&width=900&height=1200&seq=nomo-formula-place-01&orientation=portrait',
    tag: '东方风土',
  },
  {
    zh: '一愿',
    en: 'WISH',
    index: '03',
    line: '我们最终想讲的，不是食物，而是人。',
    body: '想好运、想发财、想恋爱、想被治愈、想躺平、想自由……传统文化提供灵感，当代情绪赋予角色生命。',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20artwork%20of%20a%20glowing%20warm%20paper%20lantern%20with%20faint%20floating%20golden%20blessing%20motifs%20in%20deep%20twilight%20background%20warm%20red%20and%20amber%20glow%20serene%20hopeful%20mood&width=900&height=1200&seq=nomo-formula-wish-01&orientation=portrait',
    tag: '当代人的愿望',
  },
];

export default function Formula() {
  return (
    <section id="formula" className="bg-background-100 py-16 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal mb-12 flex flex-col items-center text-center md:mb-16">
          <div className="mb-6 flex items-center gap-3">
            <span className="text-[11px] tracking-[0.34em] text-primary-600 uppercase">
              Section 02
            </span>
            <span className="h-px w-8 bg-primary-300"></span>
            <span className="text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
              The Formula
            </span>
          </div>
          <h2 className="font-heading text-3xl text-foreground-950 md:text-5xl">
            一味 <span className="text-accent-600">×</span> 一境{' '}
            <span className="text-accent-600">×</span> 一愿
          </h2>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            一味，给予它形；一境，给予它魂；一愿，给予它意义。当三者相遇，
            一个属于 NOMOISM 的角色便诞生了，我们叫它
            <span className="text-primary-600">「NOMO 灵」</span>。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {flavors.map((item, index) => (
            <article
              key={item.zh}
              className="reveal group overflow-hidden rounded-lg border border-background-200/70 bg-background-50"
              style={{ transitionDelay: `${index * 130}ms` }}
            >
              <div className="relative h-[300px] w-full overflow-hidden md:h-[380px]">
                <img
                  src={item.image}
                  alt={`${item.zh} ${item.en} · ${item.tag}`}
                  title={`NOMOISM ${item.zh}·${item.tag}`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent"></div>
                <span className="absolute left-5 top-5 font-heading text-sm tracking-[0.3em] text-background-50/80">
                  {item.index}
                </span>
                <div className="absolute bottom-5 left-5 right-5">
                  <p className="font-heading text-2xl text-background-50">
                    {item.zh}
                    <span className="ml-2 text-[11px] tracking-[0.24em] text-background-50/75 uppercase">
                      {item.en}
                    </span>
                  </p>
                  <p className="mt-1 text-xs tracking-[0.14em] text-background-50/80">{item.tag}</p>
                </div>
              </div>
              <div className="p-6">
                <p className="font-heading text-base text-foreground-950 md:text-lg">{item.line}</p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.body}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}